import { Vue, Component, Prop, px } from '@/utils';

@Component({
  name: 'svg-icon',
})
export class SvgIcon extends Vue {
  @Prop({ required: true })
  public name: string;

  @Prop({type: [Number, String]}) public size: any;
  @Prop({type: [Number, String]}) public width: any;
  @Prop({type: [Number, String]}) public height: any;
  @Prop({type: [String]}) public color: string;

  get iconName() {
    require(`@/assets/icons/svg/${this.name}.svg`);
    return `#icon-${this.name}`;
  }

  get iconStyle() {
    const styles: any = {};
    if (this.width || this.size) {
      styles.width = this.width == null ? px(this.size) : px(this.width);
    }
    if (this.height || this.size) {
      styles.height = this.height == null ? px(this.size) : px(this.height);
    }
    if (this.color) {
      styles.color = this.color;
    }
    return styles;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/svg-icon.ts